import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue";
import _imports_0 from '@/assets/images/icons/qrcode-scan.png';
var _hoisted_1 = {
  class: "scan-qr-code"
};
var _hoisted_2 = {
  key: 0,
  class: "spinner-overlay"
};
var _hoisted_3 = {
  key: 1,
  class: "d-flex fl-col fl-j-c fl-a-c"
};
var _hoisted_4 = {
  class: "container"
};
var _hoisted_5 = {
  class: "scan-booking"
};
var _hoisted_6 = {
  class: "qrcode-instruction"
};

var _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "qrcode-img"
}, null, -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_button = _resolveComponent("el-button");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    modelValue: _ctx.modalVisibility,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.modalVisibility = $event;
    }),
    "close-on-click-modal": false,
    "close-on-press-escape": false
  }, {
    default: _withCtx(function () {
      return [_ctx.loading ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_button, {
        class: "spinner",
        loading: true
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.t("qrcode.scan-booking")), 1), _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.t("qrcode.instruction")), 1), _hoisted_7])]))];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}